import React from 'react';
import styles from './lastMonthWinners.module.scss';
import { LadderPlayer, ILadderService } from '../../model/interfaces';
import { Loader } from '@ui-kit/components/loader';
import Empty from '../../../../../../ui-kit/src/components/empty';
import { ReactComponent as Swords } from '../../assets/swords.svg';
import { t } from '@base/utils/helpers';
import Tooltip from '@ui-kit/components/tooltip';
import { ReactComponent as Cup } from '../../assets/cup.svg';
import { useAsyncData } from '@utils/hooks';

export default function LastMonthWinners(props: { ladderService: ILadderService }) {
  return (
    <Tooltip overlay={<Winners ladderService={props.ladderService} />} placement="bottom">
      <Cup className={styles.cup} />
    </Tooltip>
  );
}

function Winners(props: { ladderService: ILadderService }) {
  const { data, loading } = useAsyncData(() => props.ladderService.getLastMonthWinners());

  return (
    <div className={styles.list}>
      <WinnersContent data={data} loading={loading} />
    </div>
  );
}

function WinnersContent(props: { data?: LadderPlayer[]; loading: boolean }) {
  if (props.loading) return <Loader width={50} height={50} />;
  if (!props.data) return <Empty icon={<Swords />}>{t('error')}</Empty>;

  return (
    <div>
      <h3>Last month winners</h3>
      <ol>
        {props.data.map((player) => (
          <li key={player.id}>{player.userName}</li>
        ))}
      </ol>
    </div>
  );
}
